"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("../ThemeProvider");
exports.default = react_1.forwardRef(function SportThiemeLogo(_a, ref) {
    var _b = _a.width, width = _b === void 0 ? 320 : _b, _c = _a.height, height = _c === void 0 ? 75 : _c, _d = _a.alt, alt = _d === void 0 ? 'Sport-Thieme' : _d, props = __rest(_a, ["width", "height", "alt"]);
    var isDark = ThemeProvider_1.useDarkMode()[0];
    return (jsx_runtime_1.jsx("img", __assign({ width: width, height: height, alt: alt, src: "https://pimage.sport-thieme.de/logo-st/siteLogo" + (isDark ? '-white' : '') + "-noSubline" }, props, { ref: ref }), void 0));
});
//# sourceMappingURL=SportThiemeLogo.js.map